/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_DriverInputs */

const en_orders_driver = /** @type {(inputs: Orders_DriverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Driver`)
};

const es_orders_driver = /** @type {(inputs: Orders_DriverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chofer`)
};

/**
* | output |
* | --- |
* | "Driver" |
*
* @param {Orders_DriverInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_driver = /** @type {((inputs?: Orders_DriverInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_DriverInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_driver(inputs)
	return es_orders_driver(inputs)
});